module.exports = __webpack_public_path__ + "media/images/www/ssl-067e58359df66bf4a9cc993861d1d50d.svg";